import React, { memo } from 'react'
import { VehicleInsuranceForm } from 'src/components/vehicle-insurance/VehicleInsuranceForm'
import { SecureWrapper } from '../layout/SecureWrapper'
import { Driver } from 'src/interfaces/driver'

interface Props {
  driver?: Driver
}

const VehicleInsuranceComponent = ({ driver }: Props) => {
  return (
    <SecureWrapper>
      <VehicleInsuranceForm driver={driver} />
    </SecureWrapper>
  )
}

export const VehicleInsurance = memo(VehicleInsuranceComponent)
